import React from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const BeneficaryMember = props => (
    <div className="col-md-3">
        <div className="row">
            <div className="card">
                <div className="x_title">
                    <h4>Beneficiaries </h4>
                    <div className="clearfix" />
                </div>
                {props.beneficaryList.map(appBenItem => (
                    // <Link
                    //     to={{ pathname: `/portal/beneficiary/${appBenItem.Id}` }}
                    //     params={{ personId: appBenItem.Id }}
                    //     key={shortid.generate()}
                    // >
                        <div key={shortid.generate()}>
                            <div className="col-xs-2">
                                <div className="avatar ben">
                                    <img
                                        src={require('../../../assets/img/face-1.jpg')}
                                        alt="Circle"
                                        className="img-circle img-no-padding img-responsive"
                                    />
                                </div>
                            </div>
                            <div className="col-xs-2">
                                {
                                    appBenItem.Application_Status__c === 'Rejected by Partner' ?
                                        <h3 style={{ color: 'red' }}><i className="fa fa-times" /></h3> : null
                                }
                                {
                                    appBenItem.Application_Status__c === 'Rejected by SPMF' ?
                                        (
                                            <h3 style={{ color: 'red' }}>
                                                <i className="fa fa-times" />
                                                <i className="fa fa-times" />
                                            </h3>
                                        ) : null
                                }
                                {appBenItem.Application_Status__c === 'Verified by Partner' ? (
                                    <h3 style={{ color: 'green' }}>
                                        <img
                                            src={require('../../../assets/img/tick.png')}
                                            alt="Circle"
                                            className="img-circle img-no-padding img-responsive"
                                            style={{ minWidth: '25px' }}
                                        />
                                    </h3>
                                ) : ''
                                }
                                {['Approved by Partner', 'Submitted to SPMF', 'Verified by SPMF', 'Approved by SPMF'].includes(appBenItem.Application_Status__c) ?
                                    (
                                        <h3 style={{ color: 'green' }}>
                                            <img
                                                src={require('../../../assets/img/double-tick.png')}
                                                alt="Circle"
                                                className="img-circle img-no-padding img-responsive"
                                                style={{ minWidth: '30px' }}
                                            />
                                        </h3>
                                    )
                                    : ''
                                }
                            </div>
                            <div className="col-xs-8">
                                {/* change to Full_Name__c */}
                                {props.userType !== null ?
                                    <label> {appBenItem.Full_Name__c} </label>
                                    : <label> {appBenItem.Contact_Name__r.Name} </label>}
                                <p> {appBenItem.ID_Number__c}</p>
                                <p> {appBenItem.Current_School__r ? appBenItem.Current_School__r.Name : ''}</p>
                                <p> {appBenItem.Current_Level__c}</p>
                            </div>
                            <div className="col-xs-4"></div>
                            <div className="col-xs-8">
                                <div class="btn-group" role="group">
                                    <Link
                                        to={{ pathname: `/portal/beneficiary/${appBenItem.Id}` }}
                                        params={{ personId: appBenItem.Id }}
                                    >
                                        <button type="button" class="btn btn-default">
                                            More actions
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="clearfix" />
                        </div>
                    // </Link>
                ))}
            </div>
        </div>
        <div className="row">
            <div className="x_panel">
                <div className="x_title">
                    <h4>Other Household Member </h4>
                    <div className="clearfix" />
                </div>
                {props.houseHoldList.map(appHouItem => (
                    <div className="" style={{ display: 'block' }} key={shortid.generate()}>
                        {/* <Link
                            to={{ pathname: `/portal/beneficiary/${appHouItem.Id}` }}
                            params={{ personId: appHouItem.Id }}
                        > */}
                            <div className="col-xs-3">
                                <div className="avatar ben">
                                    <img
                                        src={require('../../../assets/img/face-0.jpg')}
                                        alt="Circle"
                                        className="img-circle img-no-padding img-responsive"
                                    />
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <label> {appHouItem.Full_Name__c} </label>
                                <p> {appHouItem.Relationship_to_Applicant__c}</p>
                            </div>
                        {/* </Link> */}
                        <div className="col-xs-3">
                            <button className="btn btn-sm btn-success btn-icon">
                                <i className="fa fa-envelope" />
                            </button>
                        </div>
                        <div className=" col-xs-6 col-xs-offset-3">
                            <div class="btn-group" role="group">
                                <Link
                                    to={{ pathname: `/portal/beneficiary/${appHouItem.Id}` }}
                                    params={{ personId: appHouItem.Id }}
                                >
                                    <button type="button" class="btn btn-default">
                                        More actions
                                    </button>
                                </Link>
                            </div>
                        </div>
                        
                    </div>

                ))}
            </div>
        </div>
    </div>
);

BeneficaryMember.propTypes = {
    beneficaryList: PropTypes.array,
    houseHoldList: PropTypes.array,
};

BeneficaryMember.defaultProps = {
    beneficaryList: [],
    houseHoldList: [],
};

export default BeneficaryMember;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Application/BeneficaryMember.js
// module id = 434
// module chunks = 0